import { render } from "./LanguagePickerDropdown.vue?vue&type=template&id=58cde0af&scoped=true"
import script from "./LanguagePickerDropdown.vue?vue&type=script&lang=js"
export * from "./LanguagePickerDropdown.vue?vue&type=script&lang=js"

import "./LanguagePickerDropdown.vue?vue&type=style&index=0&id=58cde0af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cde0af"]])

export default __exports__